// extracted by mini-css-extract-plugin
export default {"root":"_1eHbv","flames":"_1Zbj0","flame":"_20GHN"};